import axios from './util/axios'

export function getGenericContentSections (location) {
  return axios.get('/api/genericcontentsections', { params: { location } })
}
